import React from "react";
import {
    Box, Typography, Divider, Card, CardContent, Stack
} from "@mui/material";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { Currency } from "../interfaces/ProducerDashboard";
import { formatMoney } from "./ProducerDashboardHelper";


type ProducerBalancesProps = {
    balance: number;
    producer_from_escrow_transferable_balance: number;
    operator_from_producer_transferable_balance: number;
    payable_balance: number;
    currency: Currency
}


export default function ProducerBalances({ balance, producer_from_escrow_transferable_balance, operator_from_producer_transferable_balance, payable_balance, currency }: ProducerBalancesProps) {

    const isToOperatorRisk = balance < Math.abs(operator_from_producer_transferable_balance);
    const isPayableRisk = balance < Math.abs(payable_balance);

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 3, mb: 4 }}>
                {balance &&
                    <Card sx={{ flex: 1, borderRadius: 3, borderLeft: '6px solid #1976d2', bgcolor: '#f0f7ff' }}>
                        <CardContent>
                            <Stack direction="row" spacing={1} alignItems="center" mb={1}><AccountBalanceWalletIcon color="primary" fontSize="small" /><Typography variant="overline" sx={{ fontWeight: 800 }}>Wallet Amount</Typography></Stack>
                            <Typography variant="h3" sx={{ fontWeight: 800 }}>{formatMoney(balance, currency)}</Typography>
                        </CardContent>
                    </Card>}

                <Card sx={{ flex: 1.5, borderRadius: 3, border: '1px solid #e0e0e0' }}><CardContent>
                    <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 800 }}>Pending Internal Transfers</Typography>
                    <Stack direction="row" spacing={3} mt={1}>
                        <Box>
                            <Typography variant="caption" color="error.main" sx={{ display: 'flex', alignItems: 'center' }}><CallMadeIcon fontSize="inherit" /> To Operator - Fee/Refund (Debit)</Typography>
                            <Typography variant="h5" sx={{ fontWeight: 700, color: isToOperatorRisk ? "error.main" : "inherit" }}>{formatMoney(operator_from_producer_transferable_balance, currency)}</Typography>
                        </Box>

                        <Divider orientation="vertical" flexItem />
                        <Box>
                            <Typography variant="caption" color="success.main" sx={{ display: 'flex', alignItems: 'center' }}><CallReceivedIcon fontSize="inherit" /> From Escrow - Payment/Credit Note (Credit)</Typography>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>{formatMoney(producer_from_escrow_transferable_balance, currency)}</Typography>
                        </Box>
                    </Stack>
                </CardContent></Card>

                <Card sx={{ flex: 1, borderRadius: 3, borderLeft: `6px solid ${isPayableRisk ? '#d32f2f' : '#ed6c02'}`, bgcolor: isPayableRisk ? '#fff5f5' : 'inherit' }}><CardContent>
                    <Typography variant="overline" sx={{ fontWeight: 800, color: isPayableRisk ? 'error.main' : 'text.secondary' }}>Awaited Payout (Payable)</Typography>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: isPayableRisk ? 'error.main' : 'inherit' }}>{formatMoney(payable_balance, currency)}</Typography>
                </CardContent></Card>
            </Box>
        </>
    );
}